if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            // La respuesta trae la sección de la ficha ENTERA, con más de un bloque de
            // recomendaciones («Productos relacionados» y «Comprados juntos»). Hay que
            // quedarse con el del mismo intent que este, no con el primero: si no, el de
            // «Comprados juntos» se rellenaba con los relacionados y salían dos veces.
            const intentOf = (el) => {
              try {
                return new URL(el.dataset.url, window.location.origin).searchParams.get('intent');
              } catch (e) {
                return null;
              }
            };
            const intent = intentOf(this);
            const candidates = Array.from(sectionInnerHTML.querySelectorAll('product-recommendations'));
            const recommendations = candidates.find((el) => intentOf(el) === intent) || candidates[0];

            if (!recommendations) return;

            if (recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block').remove();
              } else {
                this.closest('.shopify-section').remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
